var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"download-button",attrs:{"tag":"a","href":_vm.file.url,"type":"is-light","icon-left":"download","aria-label":_vm.filename,"download":""}},[_vm._v(" "+_vm._s(_vm.fileName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }